import { useSyncExternalStore } from 'react';
import type { ReachabilityMonitor, ReachabilityState } from '../network/reachability';

/**
 * React binding for a ReachabilityMonitor (ISS-445).
 *
 * The monitor is passed in rather than owned here so an app can share ONE
 * instance between React and non-React code (read helpers report outcomes
 * into the same monitor the UI subscribes to).
 */
export function useReachability(monitor: ReachabilityMonitor): ReachabilityState {
  return useSyncExternalStore(
    (onStoreChange) => monitor.subscribe(onStoreChange),
    () => monitor.getState(),
    () => 'online' as const,
  );
}
